const tagManagerConfig = {
  gtmId: 'GTM-TW8T8SX',
}

export default tagManagerConfig
